module.exports = __webpack_public_path__ + "static/media/CallTower_192x192_Full_Color.6b58817a.png";